"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * HTTP methods currently implemented by the Execute implementations (`AdapterExecuteInterface`, `RepositoryExecuteInterface`)
 */

var ExecuteMethod;

(function (ExecuteMethod) {
  ExecuteMethod["GET"] = "GET";
  ExecuteMethod["POST"] = "POST";
})(ExecuteMethod = exports.ExecuteMethod || (exports.ExecuteMethod = {}));